<template>
  <div>
    <div class="timeline">
      <div class="timeline-item active">
        <div class="circle"></div>
        <div class="label">
          <p>
            {{
              $t(
                "staking.stakingPlans.dialogDetail.planSchedule.Registration_Date"
              )
            }}
          </p>
          <p class="gray1--text">
            {{ state.detailContents.subscriptionTime | formatDate }}
          </p>
        </div>
      </div>
      <div class="timeline-item active">
        <div class="circle"></div>
        <div class="label">
          <p>
            {{
              $t(
                "staking.stakingPlans.dialogDetail.planSchedule.Start_Of_Staking_Plan"
              )
            }}
          </p>
          <p class="gray1--text">
            {{ state.detailContents.subscriptionStartDate | formatDate }}
          </p>
        </div>
      </div>
      <div class="timeline-item">
        <div class="circle"></div>
        <div class="label">
          <p>
            {{
              $t(
                "staking.stakingPlans.dialogDetail.planSchedule.Daily_Profit_Distribution_Date"
              )
            }}
          </p>

          <p class="gray1--text">
            {{ state.detailContents.profitDistributionDate | formatDate }}
          </p>
        </div>
      </div>
      <div class="timeline-item">
        <div class="circle"></div>
        <div class="label">
          <p>
            {{
              $t("staking.stakingPlans.dialogDetail.planSchedule.Plan_End_Date")
            }}
          </p>

          <p class="gray1--text">
            {{ state.detailContents.subscriptionEndDate | formatDate }}
          </p>
        </div>
      </div>
      <div class="timeline-item" v-if="state.detailContents.profitReleaseDate">
        <div class="circle"></div>
        <div class="label">
          <p>
            {{
              $t(
                "staking.stakingPlans.dialogDetail.planSchedule.Profit_Release_Date"
              )
            }}
          </p>
          <p class="gray1--text">
            {{ state.detailContents.profitReleaseDate | formatDate }}
          </p>
        </div>
      </div>
      <div class="timeline-item">
        <div class="circle"></div>
        <div class="label">
          <p>
            {{
              $t(
                "staking.stakingPlans.dialogDetail.planSchedule.Asset_Release_Date"
              )
            }}
          </p>
          <p class="gray1--text">
            {{ state.detailContents.assetReleaseDate | formatDate }}
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="
        state.detailContents.isRenewal &&
          state.detailContents.status === FiltersType.ACTIVE
      "
    >
      <v-switch
        v-model="switchStatus"
        @change="e => openRenewalDialog(e, state.detailContents.id)"
        class="custom-switch"
        :label="
          $t('staking.stakingPlans.dialogDetail.planSchedule.Plan_Renewal')
        "
        hide-details
        inset
      ></v-switch>
      <p class="my-4">
        {{
          $t(
            "staking.stakingPlans.dialogDetail.planSchedule.Enable_Auto_Renewal_Description"
          )
        }}
      </p>

      <div class="timeline">
        <div class="timeline-item">
          <div class="circle"></div>
          <div class="label">
            <p>
              {{
                $t(
                  "staking.stakingPlans.dialogDetail.planSchedule.Start_Of_Staking"
                )
              }}
            </p>
            <p class="gray1--text">
              {{ state.detailContents.subscriptionRenewStartDate | formatDate }}
            </p>
          </div>
        </div>
        <div class="timeline-item">
          <div class="circle"></div>
          <div class="label">
            <p>
              {{
                $t(
                  "staking.stakingPlans.dialogDetail.planSchedule.Daily_Profit_Distribution_Date"
                )
              }}
            </p>
            <p class="gray1--text">
              {{
                state.detailContents.renewedProfitDistributionDate | formatDate
              }}
            </p>
          </div>
        </div>
        <div class="timeline-item">
          <div class="circle"></div>
          <div class="label">
            <p>
              {{
                $t(
                  "staking.stakingPlans.dialogDetail.planSchedule.Plan_End_Date"
                )
              }}
            </p>
            <p class="gray1--text">
              {{ state.detailContents.subscriptionRenewEndDate | formatDate }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!--    renewal modal-->
    <v-dialog persistent v-model="renewalDialog" width="500">
      <v-card class="text-center gray13">
        <v-card-text>
          <h2 class="py-4">{{ dialogTitle }}</h2>
          <p>{{ dialogDescription }}</p>
          <v-btn
            :loading="isLoading"
            class="primary"
            @click="confirmRenewal()"
            >{{ confirmButtonText }}</v-btn
          >
          <v-btn class="primary ms-2" @click="cancelRenewal">{{
            $t("common.Return")
          }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import StakingService from "@/services/modules/market/staking";
import { FiltersType } from "@/store/types";
export default {
  inject: ["state"],
  data() {
    return {
      renewalDialog: false,
      tempRenewalStatus: null,
      tempSubscriptionId: null,
      previousRenewalStatus: null,
      localSwitchStatus: null,
      isLoading: false
    };
  },
  mounted() {
    // this.localSwitchStatus = this.state.detailContents.userApprovedRenewal;
  },
  computed: {
    FiltersType() {
      return FiltersType;
    },
    switchStatus: {
      get() {
        return this.localSwitchStatus;
      },
      set(newStatus) {
        this.localSwitchStatus = newStatus;
      }
    },
    dialogTitle() {
      return this.tempRenewalStatus
        ? this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Enable_Auto_Renewal"
          )
        : this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Disable_Auto_Renewal"
          );
    },
    dialogDescription() {
      return this.tempRenewalStatus
        ? this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Auto_Renewal_Description"
          )
        : this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Auto_Renewal_Disabled_Description"
          );
    },
    confirmButtonText() {
      return this.tempRenewalStatus
        ? this.$t("common.Enable")
        : this.$t("common.Disable");
    }
  },
  methods: {
    openRenewalDialog(status, id) {
      this.previousRenewalStatus = this.state.detailContents.userApprovedRenewal;
      this.localSwitchStatus = status;
      this.tempRenewalStatus = status;
      this.tempSubscriptionId = id;
      this.renewalDialog = true;
    },
    confirmRenewal() {
      const payload = {
        isAutoRenewal: this.tempRenewalStatus,
        subscriptionId: this.tempSubscriptionId
      };
      this.isLoading = true;
      StakingService.updateRenewalStatus(payload)
        .then(res => {
          if (res.data.code !== 0) {
            this.switchStatus = this.previousRenewalStatus;
          }
        })
        .finally(() => {
          this.renewalDialog = false;
          this.isLoading = false;
        });
    },
    cancelRenewal() {
      this.switchStatus = this.previousRenewalStatus;
      this.renewalDialog = false;
    }
  },
  watch: {
    "state.detailContents.userApprovedRenewal": {
      handler(newVal) {
        if (typeof newVal === "boolean" && this.localSwitchStatus !== newVal) {
          this.localSwitchStatus = newVal;
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.timeline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}

.timeline-item {
  position: relative;
  width: 100%;
}
.ltr .timeline-item::before {
  left: 5.5px;
}

.timeline-item::before {
  content: "";
  position: absolute;
  right: 5.5px;
  top: 20px;
  width: 2px;
  height: 100%;
  background-color: #888;
  z-index: 0;
}

.timeline-item:last-child::before {
  display: none;
}

.timeline-item.active::before {
  background-color: #3f51b5;
}

.circle {
  width: 12px;
  height: 12px;
  background-color: #888;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  z-index: 1;
}

.timeline-item.active .circle {
  background-color: #3f51b5;
}

.ltr .label {
  margin-left: 20px;
}
.label {
  color: var(--v-gray2-base);
  margin-right: 20px;
  margin-top: 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.custom-switch {
  label {
    color: var(--v-gray1-base) !important;
    font-size: 16px;
    font-weight: 500;
    order: -1;
    flex: unset !important;
    margin-inline-end: 12px;
  }
}
</style>
